var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#0090ff;}.a{opacity:0;}.b,.c,.d,.f,.h{fill-rule:evenodd;}.c,.e{fill:#0073c8;}.d,.g{fill:#3eaaf3;}.f{fill:#0089f2;}.h{fill:#323232;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.25 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 120,
    height: 120,
    transform: "translate(-14.25 -15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.116,57.845l17.5,30.311-1.732,1-17.5-30.311Zm-25.232,0,1.732,1-17.5,30.311-1.732-1ZM47,59V89H45V59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M32.884,57.845l1.732,1L31.64,64H29.33ZM47,59v5H45V59Zm11.116-1.155L61.67,64H59.359l-2.975-5.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M74.372,86l1.244,2.156-1.732,1L72.062,86ZM18.938,86l-1.822,3.156-1.732-1L16.628,86ZM47,86v3H45V86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M39,0H51l4,4H84a2,2,0,0,1,2,2V8H4V6A2,2,0,0,1,6,4H35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 92,
    height: 2,
    transform: "translate(0 88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4,8H86V58a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M4,8H46V60H6a2,2,0,0,1-2-2V8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(12 20)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M26,20A14,14,0,0,1,40,34H26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M78,40v2H52V40Zm0-6v2H52V34Zm0-6v2H52V28Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardIcon);
export default __webpack_public_path__ + "static/media/board-icon.023f7ccc849781c4f7573cbf1c120d01.svg";
export { ForwardRef as ReactComponent };